import { useState, useEffect } from "react";
import { UseFormReturn, Controller, get } from "react-hook-form";
import { SelectField } from "../ui";
import { brasilApiService } from "../../services/api/brasil-api/brasilapi";

// A interface continua representando a API de origem, sem alterações.
export interface IBanco {
  ispb: string;
  name: string;
  code: number | null;
  fullName: string | null;
}

type BuscarBancosProps = {
  name: string;
  label: string;
  methods: UseFormReturn<any>;
  disabled?: boolean;
};

export function BuscarBancos({
  name,
  label,
  methods,
  disabled = false,
}: BuscarBancosProps) {
  const [bancos, setBancos] = useState<IBanco[]>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  const {
    control,
    formState: { errors },
  } = methods;

  // A lógica para buscar os dados continua a mesma
  useEffect(() => {
    const fetchBancosData = async () => {
      setLoading(true);
      setErro("");
      try {
        const initialBankCode = methods.getValues(name);
        const listaResponse = await brasilApiService.getBancos();
        let listaDeBancos = listaResponse.data || [];

        if (initialBankCode) {
          const detalheResponse = await brasilApiService.getBancoByCode(
            initialBankCode
          );
          const bancoDetalhado = detalheResponse.data;
          if (
            bancoDetalhado &&
            !listaDeBancos.some((b: IBanco) => b.code === bancoDetalhado.code)
          ) {
            listaDeBancos = [bancoDetalhado, ...listaDeBancos];
          }
        }
        setBancos(listaDeBancos);
      } catch (error) {
        console.error("Erro ao buscar dados dos bancos:", error);
        setErro("Não foi possível carregar a lista de bancos.");
      } finally {
        setLoading(false);
      }
    };
    fetchBancosData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const error = get(errors, name);
        return (
          <SelectField
            label={label}
            value={field.value || ""}
            onChange={(e) => field.onChange(e.target.value)}
            disabled={disabled || loading}
            error={!!error || !!erro}
            helperText={(error?.message as string) || erro}
          >
            <option value="">
              {loading ? "Carregando..." : "Selecione..."}
            </option>
            {bancos
              .filter((banco) => banco.code !== null)
              .map((banco) => (
                <option key={banco.ispb} value={String(banco.code)}>
                  {banco.code} - {banco.fullName}
                </option>
              ))}
          </SelectField>
        );
      }}
    />
  );
}